
import { LanguageOption } from './types';

export const API_BASE_URL = '/api'; // Placeholder for your FastAPI backend URL
export const SAVED_CONFIG_KEY = 'mathHomeworkSolverConfig';
export const SAVED_HISTORY_KEY = 'mathHomeworkSolverHistory';
export const UPLOAD_CONFIRMATION_KEY = 'uploadRulesAccepted';

export const MAX_HISTORY_ITEMS = 20; // Max number of items to keep in history

export const UI_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'sr', name: 'Srpski', flag: '🇷🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'slo', name: 'Slovenščina', flag: '🇸🇮' },
  { code: 'mk', name: 'Македонски', flag: '🇲🇰' },
];

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { value: 'srpski (latinica)', label: 'srpski (latinica)', flag: '🇷🇸' },
  { value: 'srpski (ćirilica)', label: 'Српски (ћирилица)', flag: '🇷🇸' },
  { value: 'hrvatski', label: 'Hrvatski', flag: '🇭🇷' },
  { value: 'bosanski', label: 'Bosanski', flag: '🇧🇦' },
  { value: 'makedonski', label: 'Makedonski', flag: '🇲🇰' },
  { value: 'slovenian', label: 'Slovenščina', flag: '🇸🇮' },
  { value: 'bulgarian', label: 'Български', flag: '🇧🇬' },
  { value: 'english', label: 'English', flag: '🇬🇧' },
  { value: 'italian', label: 'Italian', flag: '🇮🇹' },
  { value: 'german', label: 'Deutsch', flag: '🇩🇪' },
  { value: 'french', label: 'Français', flag: '🇫🇷' },
  { value: 'albanian', label: 'Shqip', flag: '🇦🇱' },
  { value: 'turkish', label: 'Türkçe', flag: '🇹🇷' },
  { value: 'romani', label: 'Romani', flag: '🏳️‍🌈' }, // International Romani flag
];

export const faqData = [
  {
    question: "Kako AI Klikero funkcioniše?",
    answer: "Jednostavno! Slikajte matematički zadatak na bilo kom jeziku, dodajte sliku, i naša veštačka inteligencija će vam pružiti detaljno rešenje sa objašnjenjem korak po korak. Možete odabrati i razred i jezik za objašnjenje. Sva rešenja se trajno čuvaju na vašem nalogu!"
  },
  {
    question: "Da li je korišćenje AI Klikero besplatno?",
    answer: "Da, možete započeti potpuno besplatno! Svaki novi korisnik dobija 500 kredita, što je dovoljno za rešavanje otprilike 50 zadataka. Nakon toga, možete dopuniti kredite po potrebi, bez ikakve mesečne pretplate."
  },
  {
    question: "Za koje uzraste je namenjena aplikacija?",
    answer: "AI Klikero je dizajniran da pomogne roditeljima i učenicima svih uzrasta, od osnovne škole do fakulteta. Prilagođeno objašnjenje korak po korak odabranom razredu i oblastima."
  },
  {
    question: "Na kojim jezicima su dostupna objašnjenja?",
    answer: "Trenutno podržavamo više od 10 jezika, uključujući srpski, engleski, nemački i mnoge druge. Konstantno radimo na dodavanju novih jezika."
  },
  {
    question: "Šta se dešava ako slikam ceo list sa više zadataka?",
    answer: "Naša veštačka inteligencija je obučena da analizira celu sliku i pokuša da reši sve prepoznate zadatke. Dobićete rešenja za svaki zadatak pojedinačno. Za najbolje rezultate, preporučujemo da slikate jedan po jedan zadatak, posebno ako su složeni."
  },
  {
    question: "Kako funkcioniše sistem kredita?",
    answer: "Jednostavno je – nema mesečne pretplate! Kredite kupujete u paketima po potrebi. Jedan rešen zadatak obično košta 10 kredita. Ako na jednoj slici imate više zadataka, krediti će se obračunati za svaki prepoznati zadatak posebno. Da napomenemo - pridružite nam se i dobijate besplatno 500 kredita!"
  },
  {
    question: "Šta ako AI ne prepozna zadatak ispravno?",
    answer: "Naša tehnologija je veoma napredna, ali u retkim slučajevima može doći do greške. Ako se to desi, pokušajte da slikate zadatak ponovo iz drugog ugla, sa boljim osvetljenjem i jasnijim rukopisom. Ako problem i dalje postoji, naš tim za podršku je tu da pomogne."
  },
  {
    question: "Kako da postavim zadatak?",
    answer: "Slikajte zadatak i otpremite sliku. Naš AI će analizirati sliku i rešiti zadatak."
  },
  {
    question: "Koliko kredita imam?",
    answer: "Broj preostalih kredita možete videti na kontrolnoj tabli."
  },
  {
    question: "Kako da kupim još kredita?",
    answer: "Kredite možete kupiti na stranici vašeg naloga."
  },
  {
    question: "Da li mogu da vidim istoriju rešenih zadataka?",
    answer: "Da, istorija svih vaših rešenih zadataka se nalazi na stranici \"Istorija\"."
  }
];


export const faqHelperData = [
  {
    question: "Šta se dešava ako slikam ceo list sa više zadataka?",
    answer: "Naša veštačka inteligencija je obučena da analizira celu sliku i pokuša da reši sve prepoznate zadatke. Dobićete rešenja za svaki zadatak pojedinačno. Za najbolje rezultate, preporučujemo da slikate jedan po jedan zadatak, posebno ako su složeni."
  },
  {
    question: "Kako funkcioniše sistem kredita?",
    answer: "Jednostavno je – nema mesečne pretplate! Kredite kupujete u paketima po potrebi. Jedan rešen zadatak obično košta 10 kredita. Ako na jednoj slici imate više zadataka, krediti će se obračunati za svaki prepoznati zadatak posebno. Da napomenemo - pridružite nam se i dobijate besplatno 500 kredita!"
  },
  {
    question: "Šta ako AI ne prepozna zadatak ispravno?",
    answer: "Naša tehnologija je veoma napredna, ali u retkim slučajevima može doći do greške. Ako se to desi, pokušajte da slikate zadatak ponovo iz drugog ugla, sa boljim osvetljenjem i jasnijim rukopisom. Ako problem i dalje postoji, naš tim za podršku je tu da pomogne."
  },
  {
    question: "Kako da postavim zadatak?",
    answer: "Slikajte zadatak i otpremite sliku. Naš AI će analizirati sliku i rešiti zadatak."
  },
  {
    question: "Koliko kredita imam?",
    answer: "Broj preostalih kredita možete videti na kontrolnoj tabli."
  },
  {
    question: "Kako da kupim još kredita?",
    answer: "Kredite možete kupiti na stranici vašeg naloga."
  },
  {
    question: "Da li mogu da vidim istoriju rešenih zadataka?",
    answer: "Da, istorija svih vaših rešenih zadataka se nalazi na stranici \"Istorija\"."
  }
];
